import * as signals from "signals";

export default {
  resize: new signals.Signal (),
  uiLoadAssets: new signals.Signal (),
  loadingAssetsComplete: new signals.Signal (),
  start: new signals.Signal (),
  builtAll: new signals.Signal (),
  isMobileChanged: new signals.Signal (),
  orientationChanged: new signals.Signal (),
  allHide: new signals.Signal (),
  currentBetIndexHasChanged: new signals.Signal (),
  hideAutoplay: new signals.Signal (),
  betsUpdates: new signals.Signal (),
  roundEnd: new signals.Signal (),
  takeWinUpdate: new signals.Signal (),
  multiplierHistory: new signals.Signal (),


  //BaseUIComponent events
  hideLayout: new signals.Signal (),
  showLayout: new signals.Signal (),

  hideComponentEverywhere: new signals.Signal (),
  showComponentEverywhere: new signals.Signal (),
  hideComponent: new signals.Signal (),
  showComponent: new signals.Signal (),
  disableComponent: new signals.Signal (),
  enableComponent: new signals.Signal (),

  //TextComponent events
  setValue: new signals.Signal (),

  //DynamicTextComponent events
  dynamicTextValueChanged: new signals.Signal (),

  //StateButtonComponent events
  setState: new signals.Signal ()

}